export const OFFERS_AND_DISCOUNT_LOAD_START = "Offers_And_Discount_Load_Start";
export const OFFERS_AND_DISCOUNT_LOAD_END = "Offers_And_Discount_Load_End";
export const OFFERS_AND_DISCOUNT_FILTER_CLICK =
  "Offers_And_Discount_Filter_Click";
export const OFFERS_AND_DISCOUNT_COPY_BTN_CLICK =
  "Offers_And_Discount_Copy_Btn_Click";
